






























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { store, CDR, StoreState ,HellospokeContact,AppSettings} from '../../store';
import { mapState } from 'vuex';
import util from "../../lib/util"; 


@Component({
  components: {
},
computed: {
  ...mapState({
    'textpannel_contactinfo': (state: StoreState) => state.dashboard.textpannel_contactinfo ,
    'selectedContact': (state: StoreState) => state.dashboard.selectedContact,
    'User_id': (state: StoreState) => state.dashboard.logger_userid ,
     'Tag_list_': (state: StoreState) =>state.dashboard.Tag_list,
  })
    
 },
	mounted(){
		 var mm=(this as any).selectedContact;
	}
})
export default class ContactDetailInformation extends Vue {

  data() {
   return {
   }
  }


   detail_back(){
     this.$store.commit('SET_TEXTPNL_CONTACTINFO','Message_list')
   }
   _contactdetail(contact_info){
     this.$router.push({ name: 'ContactsInfo_sp2' })
     this.$store.commit("CONTACT_SIDEBARSTATSU", "personal");
     this.$store.commit('SET_TEXTPANEL_CONTACT_SELECTION',true);
    
   }
   addressLastLine(selectedContact) {
   //var selectedContact=(this as any).selectedContact;
      if(selectedContact && selectedContact.address) {
          const line1 = selectedContact.address.line1 ? selectedContact.address.line1 : '';
          const line2 = selectedContact.address.line2 ? selectedContact.address.line2 : '';
          const city = selectedContact.address.city ? selectedContact.address.city : '';
          const state = selectedContact.address.state ? selectedContact.address.state : '';
          const zip = selectedContact.address.zip ? selectedContact.address.zip : '';
           return `${line1} ${line2} ${city} ${state} ${zip}`;
      }
      else {
          return null;
      }
  }
   
    get formattedMobileNumber() {
      if((this as any).selectedContact && (this as any).selectedContact.numbers && (this as any).selectedContact.numbers.mobile && (this as any).selectedContact.numbers.mobile.number) {
          return this.formatPhoneNumber(((this as any).selectedContact as any).numbers.mobile.number);
      }
      else {
          return '';
      }
    }
     getColor(user)
    {  
      let tags = util.handletag();
      if(Object.keys(user).length == 0) return;
      return util.userColor(user.tag , user._id);
    }
    getTagbyId(tagid, i = 0)
    {
      let tags = util.handletag();
      // var tags=(this as any).Tag_list_;
      
      if(tags.map(e=>e._id).indexOf(tagid) > -1) return { type: "tag", tag: tags[tags.map(e=>e._id).indexOf(tagid)] }

      return {type: "empty", tag: []};
    }
    formatPhoneNumber(phoneNumber: any) {
        if(typeof phoneNumber === "number") {
            phoneNumber = phoneNumber.toString();
        }
        //This regex is based off the format of phone numbers
        //as they are returned in the contact list by the Kazoo API.
        //Link: https://github.com/2600hz/kazoo/blob/master/applications/crossbar/doc/contact_list.md
        //If the Hellospoke database uses a different format will adjust
        //the pattern accordingly
        const re = /(?:\+1)?(\d{3})(\d{3})(\d{4})/;
        const matches = phoneNumber.match(re);
        if(matches === null) {
               //console.log("The phone number " + phoneNumber + " could not be parsed");
            return "";
        }
        return `(${matches[1]}) ${matches[2]}-${matches[3]}`;
    }

     tagname(){
      let tags = util.handletag();
      debugger
    }

  }
